import React from 'react'
import TransactionsPage from '../../components/Fundraiser/Transactions';

const Transactions = () => {
  return (
    <TransactionsPage />
  )
}

export default Transactions;